import React from "react";
// import images from "../../../images";
import ContactUs from "../../../components/common/Status/ContactUs";
import Status from "../../../components/common/Status/Status";
import { formatDateSimple } from "../../../Utils/helper";

const QuestHistoryCard = ({ title, question, status, timestamp }) => {
  return (
    <div className="max-w-xl mx-auto bg-white rounded">
      <div className="flex flex-col border-b pb-2 border-[#E9E6E4]">
        <div className="flex justify-between items-start">
          <div className="flex flex-1 min-w-0 gap-[18px] flex-col mb-3">
            <h3 className="text-[#253FF6] font-medium text-[16px] xs:text-lg">
              {title}
            </h3>
            <p className="text-[#333333] text-[12px] xs:text-sm">{question}</p>
            <div className="flex justify-start items-end">
              <p className="text-xs text-gray-400 mt-1">
                {formatDateSimple(timestamp)}
              </p>
            </div>
          </div>

          <div className=" flex flex-col justify-between ml-4">
            <Status
              status={
                status === "NOT_STARTED"
                  ? "full"
                  : status === "NOT_STARTED"
                  ? "eligible"
                  : status === "COMPLETED"
                  ? "completed"
                  : status === "DOING"
                  ? "paused"
                  : status === "REVIEWING"
                  ? "review"
                  : status === "SAVE_QUEST"
                  ? "saved"
                  : status === "REJECT"
                  ? "rejected"
                  : "eligible"
              }
            />

            {status === "REJECT" && (
              <ContactUs
                linkNavigate="/profile/support/contactUS"
                className={"flex-row-reverse"}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestHistoryCard;
